import { render } from "./FormPayment.vue?vue&type=template&id=1c58b452&scoped=true&ts=true"
import script from "./FormPayment.vue?vue&type=script&lang=ts"
export * from "./FormPayment.vue?vue&type=script&lang=ts"

import "./FormPayment.vue?vue&type=style&index=0&id=1c58b452&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c58b452"]])

export default __exports__